import produce from 'immer'
import * as types from 'Redux/Types/LedgerTypes'

const splitExpenseDoc = (doc) => {
  const { orders = [{}], tagMappings, ...selectedDocument } = doc
  const { attributes, ...restOrders } = orders[0]
  return {
    selectedDocument,
    selectedDocAttributes: attributes,
    selectedDocMappings: tagMappings,
    selectedDocOrders: restOrders,
  }
}

const initialState = {
  deletingExpense: false,
  expenses: [],
  fetchingExpense: false,
  fetchingExpenses: false,
  lastFilters: {},
  next: null,
  previous: null,
  selectedDocAttributes: [],
  selectedDocMappings: {},
  selectedDocOrders: {},
  selectedDocument: null,
  updatingAttachments: false,
  updatingExpense: false,
  socketDocumentCreating: false,
  socketDocumentUpdating: false,
  fetchingWorkflowItems: false,
  isTabAttachementSectionUpload: false,
}

const attachDocumentsSucceeded = (draft, payload) => {
  const { selectedDocument, selectedDocAttributes, selectedDocMappings, selectedDocOrders } =
    splitExpenseDoc(payload.data)
  draft.selectedDocAttributes = selectedDocAttributes
  draft.selectedDocMappings = selectedDocMappings
  draft.selectedDocOrders = selectedDocOrders
  draft.selectedDocument = selectedDocument
  draft.updatingAttachments = false
  draft.isTabAttachementSectionUpload =
    ['PURCHASE_ORDERS', 'SHIPPING_DOCS', 'OTHER_DOCS'].indexOf(payload?.type) >= 0
}

const deleteAttachment = (draft) => {
  draft.updatingAttachments = true
}

const deleteAttachmentFailed = (draft) => {
  draft.updatingAttachments = false
}

const deleteAttachmentSucceeded = (draft, payload) => {
  const { selectedDocument, selectedDocAttributes, selectedDocMappings, selectedDocOrders } =
    splitExpenseDoc(payload.data)
  draft.selectedDocAttributes = selectedDocAttributes
  draft.selectedDocMappings = selectedDocMappings
  draft.selectedDocOrders = selectedDocOrders
  draft.selectedDocument = selectedDocument
  draft.updatingAttachments = false
}

const deleteExpense = (draft) => {
  draft.deletingExpense = true
}

const deleteExpenseFailed = (draft) => {
  draft.deletingExpense = false
}

const deleteExpenseSucceeded = (draft) => {
  draft.deletingExpense = false
}

const fetchExpense = (draft) => {
  draft.fetchingExpense = true
}

const fetchExpenseFailed = (draft) => {
  draft.fetchingExpense = false
}

const fetchExpenseSucceeded = (draft, payload) => {
  const { selectedDocument, selectedDocAttributes, selectedDocMappings, selectedDocOrders } =
    splitExpenseDoc(payload)
  draft.selectedDocAttributes = selectedDocAttributes
  draft.selectedDocMappings = selectedDocMappings
  draft.selectedDocOrders = selectedDocOrders
  draft.selectedDocument = selectedDocument
  draft.fetchingExpense = false
}

const fetchDocsWorkflowSearch = (draft) => {
  draft.fetchingWorkflowItems = true
}

const fetchDocsWorkflowSearchFailed = (draft) => {
  draft.fetchingWorkflowItems = false
}

const fetchDocsWorkflowSearchSucceeded = (draft, { data, next, previous }) => {
  draft.fetchingWorkflowItems = false
  draft.workFlowItems = data
}

const fetchExpenses = (draft) => {
  draft.fetchingExpenses = true
}

const fetchExpensesFailed = (draft) => {
  draft.fetchingExpenses = false
}

const fetchExpensesSucceeded = (draft, { data, next, previous }) => {
  draft.fetchingExpenses = false
  draft.next = next
  draft.previous = previous
  draft.expenses = data
}

const setSelectedDocument = (draft, payload) => {
  const expenseDoc = draft.original.find(({ guid }) => guid === payload)
  const { selectedDocument, selectedDocAttributes, selectedDocMappings, selectedDocOrders } =
    splitExpenseDoc(expenseDoc)
  draft.selectedDocAttributes = selectedDocAttributes
  draft.selectedDocMappings = selectedDocMappings
  draft.selectedDocOrders = selectedDocOrders
  draft.selectedDocument = selectedDocument
}

const updateExpense = (draft) => {
  draft.updatingExpense = true
}

const updateExpenseFailed = (draft) => {
  draft.updatingExpense = false
}

const updateExpenseSuccess = (draft, payload) => {
  const { selectedDocument, selectedDocAttributes, selectedDocMappings, selectedDocOrders } =
    splitExpenseDoc(payload)
  draft.selectedDocAttributes = selectedDocAttributes
  draft.selectedDocMappings = selectedDocMappings
  draft.selectedDocOrders = selectedDocOrders
  draft.selectedDocument = selectedDocument
  draft.updatingExpense = false
}

const socketDocumentUpload = (draft, payload) => {
  draft.socketDocumentCreating = true
}

const socketDocumentCreated = (draft, payload) => {
  draft.expenses = [{ ...payload, type: 'socket' }, ...draft.expenses]
  draft.socketDocumentCreating = false
}
const socketDocumentUpdated = (draft, payload, state) => {
  draft.socketDocumentCreating = true
  const payloadIndex = state.expenses.findIndex((expense) => expense.guid === payload.guid)
  if (payloadIndex > -1) {
    draft.expenses[payloadIndex] = payload
  } else {
    draft.expenses = [payload, ...draft.expenses]
  }
  if (draft.selectedDocument?.guid === payload?.guid) {
    draft.updatingExpense = true
    const { selectedDocument, selectedDocAttributes, selectedDocMappings, selectedDocOrders } =
      splitExpenseDoc(payload)
    draft.selectedDocAttributes = selectedDocAttributes
    draft.selectedDocMappings = selectedDocMappings
    draft.selectedDocOrders = selectedDocOrders
    draft.selectedDocument = selectedDocument
    draft.updatingExpense = false
  }
  draft.socketDocumentCreating = false
}

const ledgerReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    const { type, payload } = action

    switch (type) {
      case types.ATTACH_DOCUMENTS_SUCCEEDED:
        return attachDocumentsSucceeded(draft, payload)

      case types.DELETE_ATTACHMENT:
        return deleteAttachment(draft)

      case types.DELETE_ATTACHMENT_FAILED:
        return deleteAttachmentFailed(draft)

      case types.DELETE_ATTACHMENT_SUCCEEDED:
        return deleteAttachmentSucceeded(draft, payload)

      case types.DELETE_EXPENSE:
        return deleteExpense(draft)

      case types.DELETE_EXPENSE_FAILED:
        return deleteExpenseFailed(draft)

      case types.DELETE_EXPENSE_SUCCEEDED:
        return deleteExpenseSucceeded(draft)

      case types.FETCH_EXPENSE:
        return fetchExpense(draft)

      case types.FETCH_EXPENSE_FAILED:
        return fetchExpenseFailed(draft)

      case types.FETCH_EXPENSE_SUCCEEDED:
        return fetchExpenseSucceeded(draft, payload)

      case types.FETCH_DOCS_WORKFLOW_SEARCH:
        return fetchDocsWorkflowSearch(draft)

      case types.FETCH_DOCS_WORKFLOW_SEARCH_FAILED:
        return fetchDocsWorkflowSearchFailed(draft)

      case types.FETCH_DOCS_WORKFLOW_SEARCH_SUCCEEDED:
        return fetchDocsWorkflowSearchSucceeded(draft, payload)

      case types.FETCH_EXPENSES:
        return fetchExpenses(draft)

      case types.FETCH_EXPENSES_FAILED:
        return fetchExpensesFailed(draft)

      case types.FETCH_EXPENSES_SUCCEEDED:
        return fetchExpensesSucceeded(draft, payload)

      case types.SET_SELECTED_DOCUMENT:
        return setSelectedDocument(draft, payload)

      case types.UPDATE_EXPENSE:
        return updateExpense(draft)

      case types.UPDATE_EXPENSE_FAILED:
        return updateExpenseFailed(draft)

      case types.UPDATE_EXPENSE_SUCCEEDED:
        return updateExpenseSuccess(draft, payload)

      case types.SOCKET_DOCUMENT_CREATED:
        return socketDocumentCreated(draft, payload)

      case types.SOCKET_DOCUMENT_UPDATED:
        return socketDocumentUpdated(draft, payload, state)

      case types.SOCKET_DOCUMENT_UPLOAD:
        return socketDocumentUpload(draft, payload, state)
      // no default
    }
  })
}

export default ledgerReducer
